import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M9.871 10.587h4.289v1.688H9.871v-1.688zm1.162 4.664h1.887l.595-2.039H10.4z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12.001 3.757a8.243 8.243 0 1 0 0 16.486 8.243 8.243 0 0 0 0-16.486zm4.222 12.291H7.739v-.797h2.098l-.633-2.039h-.738V9.649h7.055v3.563h-.806l-.595 2.039h2.105v.797zm.023-7.289H7.785v-.938h8.461v.938z"
  })]
}), 'DoubanRing');